import { apiClient } from '@/lib/api-client';
import type { Profile } from '../../domain/entities/profile.entity';

/**
 * Só `/users/me`: o monolith não expõe mais `User` por id fora de
 * `/admin/identity` — leitura/edição de terceiro é rota admin, com role. Edição
 * do próprio cadastro pelo operador não existe neste app (ele edita o seu em
 * "Minha Conta", no user-dashboard).
 */
export class ProfileApiDatasource {
  /**
   * Usuário corrente pela **identidade efetiva** (resolvida no backend via
   * `@CurrentUser`/authUser). Sob máscara act-as, retorna o usuário-alvo — é o
   * que faz a tela de Dados Pessoais refletir a impersonação.
   */
  async getMe(): Promise<Profile> {
    const { data } = await apiClient.get<Profile>('/users/me');
    return data;
  }
}
